// // src/contexts/NotificationsContext.tsx

// import React, { createContext, useContext, ReactNode } from 'react';
// import { useNotifications } from '../Hooks/useNotifications';
// import userStateManager from '../AppWriteOAuth/UserStateManager';

// interface NotificationsContextType {
//   unreadCount: number;
//   isLoading: boolean;
//   fetchNotifications: () => Promise<void>;
//   markAsRead: () => Promise<void>;
//   markRequestAsViewed: (requestId: number) => void;
//   getUnreadBidsPerRequest: () => Record<number, number>;
//   // ✅ დაამატე ეს 2 ახალი method:
//   getUnreadJobRequests: () => Record<number, boolean>;
//   markJobRequestAsViewed: (requestId: number) => void;
// }

// const NotificationsContext = createContext<NotificationsContextType | undefined>(undefined);

// export const NotificationsProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
//   const currentUser = userStateManager.getCurrentUser();
//   const notifications = useNotifications(currentUser?.user_type || null);

//   return (
//     <NotificationsContext.Provider value={notifications}>
//       {children}
//     </NotificationsContext.Provider>
//   );
// };

// export const useNotificationsContext = () => {
//   const context = useContext(NotificationsContext);
//   if (!context) {
//     throw new Error('useNotificationsContext must be used within NotificationsProvider');
//   }
//   return context;
// };







//////////////////////// ოპტიმიზირებული ვარიანტი
// src/contexts/NotificationsContext.tsx
import React, { createContext, useContext, ReactNode, useState, useEffect } from 'react';
import { useNotifications } from '../Hooks/useNotifications';
import userStateManager, { User } from '../AppWriteOAuth/UserStateManager';

interface NotificationsContextType {
  unreadCount: number;
  isLoading: boolean;
  fetchNotifications: () => Promise<void>;
  markAsRead: () => Promise<void>;
  markRequestAsViewed: (requestId: number) => void;
  getUnreadBidsPerRequest: () => Record<number, number>;
  getUnreadJobRequests: () => Record<number, boolean>;
  markJobRequestAsViewed: (requestId: number) => void;
}

const NotificationsContext = createContext<NotificationsContextType | undefined>(undefined);

export const NotificationsProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  
  // ✅ lazy initializer — mount-ზე ერთხელ წაიკითხავს localStorage-დან
  const [userType, setUserType] = useState<string | null>(() => {
    try {
      const userStr = localStorage.getItem('user');
      if (!userStr) return null;
      const user = JSON.parse(userStr);
      return user?.user_type || null;
    } catch {
      return null;
    }
  });

  // ✅ login/logout-ზე userType განახლება
  useEffect(() => {
    const handleUserChange = (updatedUser: User | null) => {
      setUserType(updatedUser?.user_type || null);
    };

    userStateManager.addListener(handleUserChange);
    return () => userStateManager.removeListener(handleUserChange);
  }, []);

  const notifications = useNotifications(userType);

  return (
    <NotificationsContext.Provider value={notifications}>
      {children}
    </NotificationsContext.Provider>
  );
};

export const useNotificationsContext = () => {
  const context = useContext(NotificationsContext);
  if (!context) {
    throw new Error('useNotificationsContext must be used within NotificationsProvider');
  }
  return context;
};